module.exports = __webpack_public_path__ + "static/Braze-881b8b0634651fc0743a276bbb52250f.jpg";